import { Container, EmptyLayOut, EmptyText } from "pages/home/components/Layout";

// 등록된 건의/문의가 없는 경우를 위한 컴포넌트
export const EmptyContainer = () => {
  return (
    <Container
      $height={315}
      $top={14}
      $bottom={35}
      style={{ border: "1px solid #E8E8E8" }}
    >
      <EmptyLayOut>
        <EmptyText>등록된 건의/문의가 없습니다.</EmptyText>
      </EmptyLayOut>
    </Container>
  );
};
